<template>
  <footer class="bndbs-footer" :class="{ guest: !$store.state.signedIn }">
    <p class="footer-copyright mb-0 py-3 text-center">
      <span>&copy; {{ new Date().getFullYear() }}</span>
      <a href="https://bndbs.ir">تمام حقوق مادی و معنوی این وب‌سایت محفوظ است و هرگونه کپی‌برداری از آن پیگرد قانونی دارد.</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.bndbs-footer {
  background: var(--bndbs-surface, #f5f5f5);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
}
.bndbs-footer a {
  color: inherit;
  text-decoration: none;
}
</style>
